<template>
  <div :id="`${source}_forward_calls_section`" class="form_col">
    <div class="flex flex-row gap-2 items-center">
      <a-switch v-model:checked="formData.forwardCallsEnabled" size="small" />
      <span class="text-[13px] primary_color">Forward calls to</span>
    </div>

    <div v-if="formData && formData.forwardCallsEnabled" class="form_col">
      <vue-tel-input
        v-model="formData.forwardToNumber"
        :defaultCountry="defaultCountryCode"
        :dropdownOptions="{
          showFlags: true,
          showDialCodeInList: true,
          showSearchBox: true,
          searchBoxPlaceholder: 'Search country..',
        }"
        mode="international"
        :inputOptions="{
          placeholder: 'Enter phone number',
        }"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const defaultCountryCode = computed(() => store.getters["workspace/defaultCountryCode"]);

onMounted(() => {
  store.dispatch("workspace/fetchDefaultCountryCode");
});

const props = defineProps({
  source: { type: String, required: true },
  formData: { type: Object, required: true },
});
</script>
